import { Checkbox, Col } from "antd";
import FormInputDivider from "./FormInputDivider";
import { StyledForm } from "../styles";

function PortalCheckboxGroup({ input, divider, colSpan, ...props }) {
  
  return (
    <FormInputDivider key={input.name} {...divider}>
      <Col span={colSpan ? colSpan : (props.inputColSpan? props.inputColSpan : 24)} key={input.name}>
        <Col span={input?.colSpan ? input.colSpan : 24} style={{padding:"0px"}}>
            <StyledForm.Item {...input} extra={props.helpMessage}>
              <Checkbox.Group
                options={input.options}
                disabled={input?.disabled}
              />
            </StyledForm.Item>
        </Col>
      </Col>
    </FormInputDivider>
  );
}

export default PortalCheckboxGroup;